import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui";
import {
  commissionPercentStringFromRate,
  partnerShareRateFromPlatformRate,
} from "@/lib/commissionRate";
import { cn } from "@/lib/utils";

interface ActivityPartnerShareBadgeProps {
  platformCommissionRate: number;
  labelKey?: "detail.partnerShareBadge" | "card.partnerShare";
  className?: string;
}

export function ActivityPartnerShareBadge({
  platformCommissionRate,
  labelKey = "detail.partnerShareBadge",
  className,
}: ActivityPartnerShareBadgeProps) {
  const { t } = useTranslation("activities");
  const partnerShareRate = partnerShareRateFromPlatformRate(
    platformCommissionRate,
  );

  return (
    <Badge
      variant="outline"
      size="sm"
      className={cn("font-normal tabular-nums", className)}
      title={t("detail.partnerShareHint")}
    >
      {t(labelKey, {
        percent: commissionPercentStringFromRate(partnerShareRate),
      })}
    </Badge>
  );
}
